export const LocalMixin = {
  computed: {
    local() {
      return this.$root.$i18n.locale;
    }
  }
};
